import React from "react";
import TransactionsView from "@/components/TransactionsView";

const IncomePage = () => (
  <TransactionsView
    kind="gelir"
    title="Gelirler"
    subtitle="Müşteri ödemeleri ve tahsilatlar"
    testIdPrefix="income"
  />
);

export default IncomePage;
